type MonitoringSource = 'PRISYNC_ENGINE' | 'DATAEDIS' | 'HYBRID'

/**
 * WEG-2291: Total Price is offered on channel-based panels and on hybrid ones.
 *
 * A hybrid panel mixes channel-tracked URLs, which carry an additional cost
 * from the feed, with engine-tracked URLs, which have none. The engine-tracked
 * ones are counted at their listed price rather than blocking the feature for
 * the whole panel - see ENGINE_URL_FALLBACK_NOTE.
 *
 * Kept in one place because the setting screen and the product card both gate
 * on it, and they used to do so with their own copy of the comparison.
 */
export const isTotalPriceAvailable = (
  monitoringSource: MonitoringSource | undefined,
): boolean => monitoringSource === 'DATAEDIS' || monitoringSource === 'HYBRID'

export const ENGINE_URL_FALLBACK_NOTE =
  'Manually added URLs are tracked by the Prisync engine, which does not ' +
  'collect shipping or handling fees. They have no additional cost, so they ' +
  'are counted at their listed price.'
